import * as enums from '../common/enums';
import { MapSelectionTool } from './tools/MapSelectionTool';
import { AppConfig } from '../app.config';
import { Point } from '../common/Point';

// number of track trail points
export function trackTrailsCount() {
  return AppConfig.settings.params.trackTrailsCount;
}

// in seconds
export function trackVectorLength() {
  return AppConfig.settings.params.trackVectorLength;
}

// plots history in seconds
export function plotsHistory() {
  return AppConfig.settings.params.plotsHistory;
}

//
// Map fonts
//
export const MAP_FONT: String = "Verdana";
export const LARGE_FONT: string = `18pt ` + MAP_FONT;
export const NORMAL_FONT: string = `14pt ` + MAP_FONT;
export const SMALL_FONT: string = `11pt ` + MAP_FONT;
export const EXTRA_SMALL_FONT: string = `6pt ` + MAP_FONT;

//
// Coordinates adjustment
//
export var deltaX = 0.0;
export var deltaY = 0.0;
export function setCooordAdjust(adjustX: number, adjustY: number) {
  deltaX = adjustX;
  deltaY = adjustY;
}

//
// Track trail maximum duration (seconds)
export var trackTrailMaxDuration = 120;
export var trackLifeTimeMaxTime = 100;
export function setTrackTrailMaxDuration(duration: number) {
  trackTrailMaxDuration = duration;
}

export var acousticHistSnsId: number = 0;
export function setAcousticHistSnsId(val) {
  acousticHistSnsId = val;
}

export var selectedIds = new Set();
export function clearSelectedIds() {
  selectedIds.clear();
}
export function setSelectedIds(ids) {
  selectedIds = ids;
}

// Contains NeWMI point (x,y) or null if cursor outside of map
export var mapCoordinate: Point = null;
export var savedRClickP: Point = null;
export function setMapCoordinate(mapPoint: Point) {
  mapCoordinate = mapPoint;
}
export function save2Secondary() {
  savedRClickP = mapCoordinate;
}

// Main map selection tool
export var mainMapSelectionTool: MapSelectionTool = null;
export function setMainMapSelectionTool(tool: MapSelectionTool) {
  mainMapSelectionTool = tool;
}

export function colorOfIdentity(identity: enums.Hostility) {
  return [0.64, 0.06, 0.66, 1]; // purple

  // this section determines color based on hostility...
  let color = [1, 1, 1, 1]; // white
  if (identity == enums.Hostility.Pending || identity == enums.Hostility.Unkn)
    color = [1.00, 1.00, 0.50, 1.0]; // yellow
  else if (identity == enums.Hostility.AssumedFriend || identity == enums.Hostility.Friend)
    color = [0.50, 0.875, 1.00, 1.0]; // blue
  else if (identity == enums.Hostility.Neutral)
    color = [0.66, 1.00, 0.66, 1.0]; // green
  else if (identity == enums.Hostility.Suspect || identity == enums.Hostility.Hostile)
    color = [1.00, 0.50, 0.50, 1.0]; // red
  return color;
}

export function colorOfPlot(correlated: enums.PlotCorr, age: number) {
  if (age < 0.15)
    age = 0.15;
  // if (correlated)
  //   return [0.0, 0.98, 0.0, age]; // correlated = Green
  // else
  //   return [1.0, 0.95, 0.04, age]; // uncorrelated = Yellow

  switch (correlated) {
    case enums.PlotCorr.NotRelevant:
      return [0.39, 0.05, 0.5, age]; // correlated = Purple
    case enums.PlotCorr.Ambiguous:
      return [1.0, 0.95, 0.04, age]; // uncorrelated = Yellow
    case enums.PlotCorr.Correlated:
      return [0.0, 0.98, 0.0, age]; // correlated = Green
    case enums.PlotCorr.UnCorrelated:
      return [1.0, 0.0, 0.0, age]; // notrelevent = Red
    case enums.PlotCorr.Tentative:
      return [0.0, 1.0, 1.0, age]; // tentative = Aqua
  }

}

